import { JsonObject, JsonProperty } from "typescript-json-serializer";

@JsonObject()
export class CustomStationCode {
  @JsonProperty("Code") code: string;
  @JsonProperty("ConnectorId") connectorId: number;
  @JsonProperty("StationSubType") stationSubType: string;
  @JsonProperty("StationSubTypeId") stationSubTypeId: number;
  @JsonProperty("MeterSerialNumber") meterSerialNumber: string;
}
